import { ArrowUp } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { View, XStack, YStack } from "tamagui";
import { PrimaryCheckText } from "../../core/components/PrimaryCheck";
import { ModuleBlock } from "../../ui/Block";
import { Body } from "../../ui/Body";
import { Box } from "../../ui/Box";
import { ModuleSetupBase } from "../core/ModuleUIRenderer";
import { DateDue } from "./LateDate";
import type ReminderModuleModel from "./ReminderModuleModel";
import { ReminderUI } from "./ReminderUI";

export const ReminderModuleUI = observer(
  ({ module }: { module: ReminderModuleModel }) => {
    return (
      <View>
        {!module.data.title && (
          <Box>
            <XStack gap="$medium">
              <ArrowUp />
              <Body>Set your title above!</Body>
            </XStack>
          </Box>
        )}

        <ReminderUI module={module} />
      </View>
    );
  },
);

export const ReminderModuleBlockUI = observer(
  ({ module }: { module: ReminderModuleModel }) => {
    const snapshot = module.data.snapshot;
    const isCompleted = module.isCompleted;

    let timeRow: JSX.Element;
    if (isCompleted) {
      timeRow = <PrimaryCheckText text={"Completed"} />;
    } else {
      timeRow = <DateDue dateDue={snapshot.dateDue} />;
    }

    return (
      <ModuleBlock module={module} infoRowItems={module.infoRowItems}>
        {timeRow}
      </ModuleBlock>
    );
  },
);

export const ReminderModuleSetupUI = observer(
  ({ module }: { module: ReminderModuleModel }) => {
    return (
      <YStack gap="$larger">
        <ModuleSetupBase
          module={module}
          title="Event"
          titlePlaceholder="Set title..."
          description="Start by adding an icon and title, you will add details in the next step"
        />
      </YStack>
    );
  },
);
